import {
    Box,
    Button,
    Card,
    FormControl,
    Grid,
    MenuItem,
    Select,
    TextField,
    Typography
} from "@mui/material";
import { useEffect, useState } from "react";
import {
    getEscalaCobrancaPromotor,
    getReservaStatusOptions,
    storeMotor,
} from "../../services/motorService";

const ItemDetails = ({ item, onClose, handleEditRefetchData }) => {
    const [statusReservaOptions, setStatusReservaOptions] = useState([]);
    const [promotoresOptions, setPromotoresOptions] = useState([]);

    const [selectedStatus, setSelectedStatus] = useState(0);
    const [selectedPromotor, setSelectedPromotor] = useState(0);
    const [observacao, setObservacao] = useState(item.observacao);
    const [motivoCancelamento] = useState(item.motivo_cancelamento);

    useEffect(() => {
        const fetchOptions = async () => {
            const statusOptions = await getReservaStatusOptions();
            const promotoresOptions = await getEscalaCobrancaPromotor();

            setStatusReservaOptions(statusOptions);
            setPromotoresOptions(promotoresOptions);

            const statusEncontrado = statusOptions.find(
                (status) => status.ds_status === item.status
            )
            if (statusEncontrado) {
                setSelectedStatus(statusEncontrado.id_status);
            }

            // const promotorEncontrado = promotoresOptions.find(
            //     (promotor) => promotor.nome_promotor === item.consultor_responsavel
            // )
            // if (promotorEncontrado) {
            //     setSelectedPromotor(promotorEncontrado.id_promotor)
            // }
        };
        fetchOptions();
    }, [item]);

    const handleSubmitEdit = async () => {
        try{
            const motorObj =  {
                id_status: selectedStatus,
                motivo_cancelamento: motivoCancelamento,
                observacao: observacao,
                // id_promotor: selectedPromotor,
                codreferencia: item.codreferencia,
                numreserva: item.numreserva
            };
            const result = await storeMotor(motorObj)
            if(result.success){

            } else {
                window.alert('Erro ao adicionar ao motor')
            }
            handleEditRefetchData()
            onClose()
        } catch (e) {}
    };

    return (
        <Card>
        <Box sx={{ p: 3, minWidth: 1050, backgroundColor: "#f9fafb" }}>
            <Typography variant="body1">{item.numreserva} - {item.codreferencia}</Typography>
            <Grid container spacing={3}>
                <Grid item size={6}>
                    <FormControl fullWidth>
                    <Select
                        value={selectedStatus}
                        onChange={(e) => setSelectedStatus(e.target.value)}
                        sx={{
                            fontWeight: !selectedStatus ? 600 : 500,
                            fontFamily: 'Montserrat',
                        }}
                    >
                        <MenuItem
                            value={0}
                            sx={{
                                fontWeight: 600,
                                fontFamily: 'Montserrat',
                            }}
                        >
                            SELECIONE UM STATUS
                        </MenuItem>
                        {statusReservaOptions.map((option) => (
                            <MenuItem
                                key={option.id_status}
                                value={option.id_status}
                                sx={{
                                    fontWeight: 500,
                                    fontFamily: 'Montserrat',
                                }}
                            >
                                {option.ds_status}
                            </MenuItem>
                        ))}
                    </Select>
                    </FormControl>
                </Grid>
                <Grid item size={3}>
                    <TextField
                        fullWidth
                        label="Motivo Cancelamento"
                        value={motivoCancelamento || ""}
                        slotProps={{
                            input: {
                                readOnly: true,
                            },
                        }}
                    />
                </Grid>
                    {/* <Grid item size={3}>
                        <TextField
                            fullWidth
                            label="Promotor"
                            value={item.nome_promotor || ""}
                            slotProps={{
                                input: {
                                    readOnly: true,
                                },
                            }}
                        />
                    </Grid> */}
                {/* <Grid item size={6}>
                    <FormControl fullWidth>
                    <Select
                        value={selectedPromotor}
                        onChange={(e) => setSelectedPromotor(e.target.value)}
                        sx={{
                            fontWeight: !selectedPromotor ? 600 : 500,
                            fontFamily: 'Montserrat',
                        }}
                    >
                        <MenuItem
                            value={0}
                            sx={{
                                fontWeight: 600,
                                fontFamily: 'Montserrat',
                            }}
                        >
                            ESCOLHA O CONSULTOR RESPONSÁVEL
                        </MenuItem>
                        {promotoresOptions.map((option) => (
                            <MenuItem
                                key={option.id_promotor}
                                value={option.id_promotor}
                                sx={{
                                    fontWeight: 500,
                                    fontFamily: 'Montserrat',
                                }}
                            >
                                {option.nome_promotor}
                            </MenuItem>
                        ))}
                    </Select>
                    </FormControl>
                </Grid> */}
                <Grid item size={6}>
                    <TextField
                    fullWidth
                    label="Observação"
                    multiline
                    minRows={5}
                    value={observacao}
                    onChange={(e) => setObservacao(e.target.value)}
                    />
                </Grid>
            </Grid>
            <Box
            sx={{
                mt: 4,
                display: "flex",
                justifyContent: "flex-start",
            }}
            >
            <Button
                sx={{ color: "#fff", maxWidth: "280px" }}
                color="fifth"
                variant="contained"
                onClick={handleSubmitEdit}
                disabled={!selectedStatus}
            >
                Salvar Alterações
            </Button>
            </Box>
        </Box>
        </Card>
    );
};

export default ItemDetails;
